<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Campos</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Campos</small></h1>

@if(!office && !showEditOffice){
<div class="scrollable">
    <panel [noButton]="true">

        <div class="d-flex justify-content-between align-items-center mb-4">
            <input type="text" class="form-control form-control-sm w-75"
                (keyup.enter)="filterOffices($event.target.value)" placeholder="Buscar por nombre...">
            <button class="btn btn-success btn-xs" (click)="addOffice()"> <i class="fas fa-plus me-1"></i> Nuevo</button>
        </div>

        @if(offices?.length > 0){
        <div class="card-list">
            @for(office of offices; track office.id; let i = $index){
            <div class="card-item" [class.item-disabled]="!office.enabled">
                <div class="card-row">
                    <div class="card-info">
                        <span class="card-badge">{{ office.acronym }}</span>
                        <span class="card-title">{{ office.name }}</span>
                    </div>

                    <div class="card-actions">
                        <button class="btn btn-xs btn-ghost" (click)="moveUp(i)" [disabled]="i === 0"
                            ngbTooltip="Subir">
                            <i class="fas fa-chevron-up"></i>
                        </button>
                        <button class="btn btn-xs btn-ghost" (click)="moveDown(i)" [disabled]="i === offices.length - 1"
                            ngbTooltip="Bajar">
                            <i class="fas fa-chevron-down"></i>
                        </button>
                        @if (office.enabled) {
                        <i class="fas fa-check-circle status-icon enabled" (click)="toggleOffice(office)"
                            ngbTooltip="Habilitado — click para deshabilitar"></i>
                        } @else {
                        <i class="fas fa-times-circle status-icon disabled" (click)="toggleOffice(office)"
                            ngbTooltip="Deshabilitado — click para habilitar"></i>
                        }
                        <button class="btn btn-xs btn-ghost text-primary" (click)="setEditOffice(office)" ngbTooltip="Editar">
                            <i class="fas fa-edit"></i>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <div class="text-center py-5 text-muted">
            <i class="fas fa-building fs-1 mb-3 d-block"></i>
            <span>No hay registros para mostrar.</span>
        </div>
        }

    </panel>
</div>
}@else{
<ng-container>
    <app-edit-office [office]="office" (close)="showEditOffice = false; office = null"
        (update)="getOffices()"></app-edit-office>
</ng-container>
}
